import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-energy-by-tariff-period',
  standalone: true,
  imports: [ChartModule],
  templateUrl: './energy-by-tariff-period.component.html',
  styleUrl: './energy-by-tariff-period.component.css'
})
export class EnergyByTariffPeriodComponent implements OnInit {
  data: any;
  options: any;

  @Input() consumption: number[] = [31000, 28000, 31000];
  @Input() kwhCosts: number[] = [0.11, 0.11, 0.11];
  @Input() labels: string[] = ['F1', 'F2', 'F3'];

  constructor() {
  }

  ngOnInit(): void {
    this.updateChart();
  }

  updateChart(): void {
    Chart.register(ChartDataLabels);

    const datasets = this.labels.map((label, index) => {
      return {
        type: 'bar',
        label: this.kwhCosts[index] !== undefined ? `${this.kwhCosts[index]}€/kWh` : '',
        backgroundColor: ['#A9BE92', '#BDCAAC', '#D4DFC9'][index % 3],
        data: this.consumption.map((value, i) => (i === index ? value : null)),
        stack: 'consumption',
        borderRadius: 12,
        datalabels: {
          display: (ctx: any) => ctx.raw !== null,
          color: '#000000',
          font: {
            size: 12,
            weight: 'normal',
            family: 'Gilroy',
          },
          formatter: (value: number | null) => value !== null ? `${value} kWh` : '',
        },
      };
    });

    this.data = {
      labels: this.labels,
      datasets: datasets
    };

    this.options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: true,
            font: {
              size: 12,
            },
          },
        },
        datalabels: {
          anchor: 'center',
          align: 'center',
        },
      },
      scales: {
        x: {
          stacked: true,
          title: {
            display: true,
            font: {
              size: 12,
              weight: 'normal',
              family: 'Gilroy',
            },
          },
          grid: {
            display: false,
          },
        },
        y: {
          beginAtZero: true,
          display: false,
          grid: {
            display: false,
          },
          ticks: {
            callback: (value: number) => `${value} kWh`,
          },
        },
      },
    };
  }
}
